import { ComparableMetric, ListedMetric, MetricRequest } from '@core/models/metric.models'
import { Player, PlayerSummary } from '@core/models/player.models'
import { PlayerPosition } from '@core/enums/player.enums'
import { MetricDetailSubHeader } from '@features/metric-detail/models/metric-detail.models'
import { PLAYER_POSITION_KEYS } from '@core/constants/player.constants'
import { PLACEHOLDER_IMAGES } from '@mediacoach/ui'

export const parsePlayerToMetricDetailRequest = (
  context: Player,
  value: ListedMetric | ComparableMetric,
  playerPosition: PlayerPosition
): MetricRequest => ({
  seasonId: context.seasonId,
  competitionId: context.competitionId,
  teamId: context.teamId,
  playerId: context.playerId ?? context.id,
  metricKey: value.key,
  playerPosition
})

export const parsePlayerMatchToMetricDetailRequest = (
  context: Player,
  value: ListedMetric | ComparableMetric,
  playerPosition: PlayerPosition
): MetricRequest => ({
  matchId: context.id,
  teamId: context.teamId,
  playerId: context.playerId ?? context.id,
  metricKey: value.key,
  playerPosition
})

export const parsePlayerMetricDetailSubHeader = (metricContext: PlayerSummary): MetricDetailSubHeader => ({
  imageA: metricContext.portraitLogo,
  numberA: metricContext.shirtNumber,
  textA: metricContext.formattedName,
  subTextA: metricContext.playerPosition,
  imageAStyleClass: 'mcm-metric-detail__avatar',
  placeholderA: PLACEHOLDER_IMAGES.PLAYER,
  secondaryImageA: metricContext?.team?.portraitLogo,
  secondaryPlaceholderA: PLACEHOLDER_IMAGES.TEAM,
  positionData: {
    playerPosition: metricContext.playerPosition,
    playerPositionKey: PLAYER_POSITION_KEYS[metricContext.playerPosition],
    genericPositionKey: metricContext.genericPositionKey,
    specificPositionKey: metricContext.specificPositionKey
  }
})
